export const PROJECT_TYPES = { scrum: 'scrum', kanban: 'kanban', retrospective: 'retrospective' };

export const PROJECT_TYPE_CONFIG = {
  scrum:         { label: 'Scrum',         description: 'Time-boxed sprints with planning and review cycles' },
  kanban:        { label: 'Kanban',        description: 'Continuous flow with priority-based organization' },
  retrospective: { label: 'Retrospective', description: 'Sprint retrospectives: reflect, identify improvements, and track actions' },
};
